import { compile_content } from "../../scripts/tools/compile_content.js";
import { setFrontNews } from "../../scripts/news.js";
import { calenderFrontpage } from "../../scripts/calendar";
import { campaignsFront } from "../modules/campaigns";
import language from "../../scripts/translation";
import { getPageType } from '../../scripts/general_functions.js';
import { decodeIfNeeded } from "#templates/pages/content";

export default (client) => {
    if (client.frontpage) {
        let apiLang = "nb_no";
        switch (window.serverdata.configMeta.aim.lang) {
            case "nb":
            case "nn":
                apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
                break;
            case "en":
                apiLang = "en_us";
                break;
        }
        apiLang = localStorage.getItem("currentLanguage") || apiLang;

        let apiCall = `${window.apiUrl}/api/Public/articles`;
        let apiParameters = `/${client.frontpage}?subscriptionId=${client.clientId}&language=${apiLang}&includeCategories=true&getRecursiveContent=true`;

        fetch(apiCall + apiParameters)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            let html = decodeIfNeeded(data.contentObject);
            html = compile_content(html, data);
            $("#result__loadfrontpage").append(html);
        })
        .catch((error) => {
            console.error('Fetch error:', error);
        });

        // fetch(`${window.apiUrl}/api/Public/atricles/${client.frontpage}/${client.clientId}`).then(response => response.json()).then(data => {
        //     let html = decodeURIComponent(data.contentObject);

        //     html = compile_content(html, data);
        //     $("#result__loadfrontpage").append(html);
        // })

        return `<div id='result__loadfrontpage'></div>`;
    }
    else {
        return `
            <div class="section frontpage__section">
                <div class="container">
                    <div class="row ">
                        <div class="col-md-12">
                            No frontpage defined
                        </div>
                    </div>
                </div>
            </div>`;
    }
}
